export default [
  { routeName: "studentsEdit", tabTitle: "Datos del alumno" },
  { routeName: "students-trainingCourseInscriptions", tabTitle: "Histórico de formaciones" },
  { routeName: "students-documents", tabTitle: "Documentos" },
  { routeName: "students-files", tabTitle: "Documentación" },
];
